(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4858],{

/***/ 24229:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/login",
      function () {
        return __webpack_require__(34507);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ login; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(68875);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./src/mosanic/auth/AuthForm.js + 3 modules
var AuthForm = __webpack_require__(36086);
// EXTERNAL MODULE: ./src/mosanic/auth/Wrapper.js
var Wrapper = __webpack_require__(43049);
;// CONCATENATED MODULE: ./src/mosanic/auth/Login.js





var Login = function(param) {
    var verifyCode = param.verifyCode, resetCode = param.resetCode;
    // const isAuth = useSelector(isAuthSelector)   
    var router = (0,next_router.useRouter)();
    if (resetCode) router.push("/reset?resetCode=".concat(resetCode));
    // useEffect(() => {
    //     if(isAuth) router.push('/')
    // },[isAuth])
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper/* default */.Z, {
        colorSchema: "light",
        mt: "-40px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthForm/* AuthForm */.B, {
            verifyCode: verifyCode,
            verify: true,
            accountActions: true
        })
    });
};
/* harmony default export */ var auth_Login = (Login);

;// CONCATENATED MODULE: ./src/pages/app/login/index.js




var SignInPage = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref;
    var query = (ref = (0,next_router.useRouter)()) === null || ref === void 0 ? void 0 : ref.query;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_Login, {
        verifyCode: query === null || query === void 0 ? void 0 : query.verify,
        resetCode: (query === null || query === void 0 ? void 0 : query.resetCode) || (query === null || query === void 0 ? void 0 : query.reset)
    });
};
/* harmony default export */ var login = (SignInPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(24229); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);